import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs, bounds } from "../utils/index"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"
import Sticky from "../../scripts/components/Sticky"
import store from "../store"
import { ScrollTrigger } from "../libraries/gsap/index"

export default class Voucher extends Component {
  constructor(obj) {
    super(obj)

    this.animate()
  }

  animate() {
    const inner = qs(".inner", this.el)
    const items = qsa(".top, .bottom, .parenthesis, .center", this.el)

    gsap.from(inner, {
      scale: 0,
      duration: 1.2,
      scrollTrigger: {
        trigger: inner,
        start: "top bottom",
      },
    })

    gsap.from(items, {
      y: 50,
      autoAlpha: 0,
      delay: 0.6,
      duration: 1.2,
      stagger: 0.1,
      scrollTrigger: {
        trigger: items,
        start: "top bottom",
      },
    })
  }
}
